import { useUserData } from '../functions/TerminalFunc';
import Statement from '../functions/TerminalStatement';
import './_Terminal.scss';

function Terminal({ onOpenResumeModal }) {
  const { userData, typing, status } = useUserData();

  const userInfo = userData ? [
    { label: `${userData.name}.currentLocation`, content: userData.contactInfo.currentLocation },
    {
      label: `${userData.name}.contactInfo`,
      content: [
        { url: `mailto:${userData.contactInfo.email}`, text: userData.contactInfo.email },
        { url: userData.contactInfo.linkedIn, text: 'linkedin' },
        { url: userData.contactInfo.github, text: 'gitHub' }
      ],
      isLink: true
    },
    {
      label: `${userData.name}.resume`,
      content: [{ onClick: onOpenResumeModal, text: '/xin_resume.pdf' }],
      isLink: true
    },
    { label: `${userData.name}.interests`, content: userData.interests.hobbies, isArray: true },
    { label: `${userData.name}.education`, content: userData.education },
    { label: `${userData.name}.skills`, content: userData.skills, isArray: true },
  ] : [];

  const prompt = status === 'error'
    ? 'Unable to load portfolio data.'
    : userData?.consoleText || 'Loading...';

  // Responsive percentage placeholders matching statement pairs
  const skeletonPairs = [
    { labelWidth: '38%', contentWidth: '55%' },
    { labelWidth: '30%', contentWidth: '70%' },
    { labelWidth: '24%', contentWidth: '40%' },
    { labelWidth: '28%', contentWidth: '78%' },
    { labelWidth: '32%', contentWidth: '88%' },
    { labelWidth: '22%', contentWidth: '94%' },
  ];

  const isLoading = status === 'loading' || !userData;

  return (
    <section className="terminal" aria-label="Portfolio information">
      {/* Top Window Bar */}
      <div className="terminal-header" aria-hidden="true">
        <span className="header-button red" />
        <span className="header-button yellow" />
        <span className="header-button green" />
      </div>

      <div className="terminal-window">
        {/* Terminal Code Line Shimmer Sweep Placeholders during fetch */}
        {isLoading ? (
          <div className="terminal-skeleton-container">
            {skeletonPairs.map((pair, index) => (
              <div className="terminal-skeleton-group" key={index}>
                <div
                  className="terminal-skeleton-line label"
                  style={{ width: pair.labelWidth }}
                />
                <div
                  className="terminal-skeleton-line content"
                  style={{ width: pair.contentWidth }}
                />
              </div>
            ))}
          </div>
        ) : (
          /* Real Syntax-Highlighted Statements with translateY Glide Fade-in */
          <div className="terminal-resolved-wrapper is-visible">
            {userInfo.map(info => (
              <Statement key={info.label} label={info.label} content={info.content} isLink={info.isLink} />
            ))}
            <div className="statement">
              <div className="input-statement" aria-live="polite">
                {prompt}
                <span aria-hidden="true">{typing && status !== 'error' ? '|' : ''}</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

export default Terminal;
